import React, { Component } from 'react';
import { connect } from 'react-redux';
import { withRouter } from '~HOC';
import { FormattedMessage, injectIntl } from 'react-intl';
import { dateDiff, fullMonths } from '../../../../utils/consts/months';
import { gatewayApi } from '../../../../services/apis';
import { numberWithCommas } from '../../../../utils/consts/index';
import propTypes from 'prop-types';
import { checkMobileDevice } from '../../../../utils/utility/index';

import {
  FlightPath,
  FlightCancelRules,
  Modal,
  Tooltip,
} from '../../../../component';
import {
  DepartureAirplaneIcon,
  ArrivalAirplaneIcon,
  ExternalLinkIcon,
  SuitcaseIcon,
} from '~svg';
import {
  returnFlightDate,
  returnFormatTime,
  returnAirlineLogos,
} from '../../../../utils/utility/booking';
import '../flightInformation/flightInformation.scss';

//#endregion
class BookingFlightDetails extends Component {
  constructor(props) {
    super(props);
    this.state = {
      cancelrules: '',
      showCancelRuleModal: false,
      showLoading: false,
      selectedIndex: -1,
    };
  }

  //#region  Start Scope: Call API
  fetchCancelData = (item, index) => {
    let { flight, showPrice } = this.props;
    let selectFlight = JSON.parse(sessionStorage.getItem('selectFlight'));
    let obj = {
      providerType: showPrice ? selectFlight.providerType : flight.ProviderType,
      sequenceNumber: showPrice
        ? selectFlight.sequenceNumber
        : flight.SequenceNumber,
      combinationId: showPrice
        ? selectFlight.combinationId
        : flight.CombinationId,
      gatewayData: showPrice ? selectFlight.gatewayData : flight.GatewayData,
      itineraryFlights: this.createItinerary(item),
    };
    gatewayApi
      .cancelRules({ data: obj })
      .then((result) => {
        this.setState(
          {
            showLoading: false,
            detailIndex: index,
            cancelingRuleText:
              result.length && result[0].cancelingRuleText !== ''
                ? result[0].cancelingRuleText
                : '',
            miniRulesPriceText:
              result.length &&
              result[0].cancelingRuleText === '' &&
              result[0].cancelingRule.length === 0 &&
              result[0].flightRule &&
              result[0].flightRule.miniRulesPriceText
                ? result[0].flightRule.miniRulesPriceText
                : null,
            cancelingRule:
              result[0] && result[0].cancelingRule.length
                ? result[0].cancelingRule
                : [],
            noCancelRules:
              (result[0] && result[0].cancelingRule.length > 0) ||
              (result.length && result[0].cancelingRuleText !== '') ||
              (result &&
                result[0].flightRule &&
                result[0].flightRule.miniRulesPriceText)
                ? null
                : this.props.intl.formatMessage({
                    id: 'booking.nocancelrules',
                  }),
          },
          () => {
            this.setState({ showCancelRuleModal: true }, () => {});
          },
        );
      })
      .catch((error) => {
        this.setState({
          detailIndex: index,
          showLoading: false,
          showCancelRuleModal: true,
          cancelingRuleText: '',
          cancelingRule: [],
          noCancelRules: this.props.intl.formatMessage({
            id: 'booking.nocancelrules',
          }),
        });
      });
  };
  //#endregion
  //#region Start Scope:Functions
  createItinerary = (item) => {
    let itinerary = [];
    item.flights.forEach((element) => {
      let obj = {};
      obj.gatewayCode = item.gateway.code;
      obj.airlineCode = element.operatingAirline.code;
      obj.resBookDesigCode = element.resBookDesigCode;
      obj.gatewayData = element.gatewayData;
      itinerary.push(obj);
    });

    return itinerary;
  };

  //#endregion
  //#region Start Scope:Render

  // show modal to show cancelation rules
  renderCancelRulesModal = () => {
    let {
      cancelingRuleText,
      cancelingRule,
      noCancelRules,
      miniRulesPriceText,
      showCancelRuleModal,
    } = this.state;
    return (
      <Modal
        isOpen={showCancelRuleModal}
        onClose={() => this.setState({ showCancelRuleModal: false })}
      >
        <div
          className={`modal-body pt-0 font-smaller text-capitalize text-center `}
          style={{
            overflowY:
              checkMobileDevice() || !cancelingRuleText ? 'auto' : 'scroll',
            maxHeight:
              checkMobileDevice() || !cancelingRuleText ? 'auto' : '85vh',
          }}
        >
          <FlightCancelRules
            cancelingRuleText={cancelingRuleText}
            cancelingRule={cancelingRule}
            noCancelRules={noCancelRules}
            miniRulesPriceText={miniRulesPriceText}
          />
        </div>
      </Modal>
    );
  };

  //show airplane name if we have the data
  renderAirplaneType = (flight, index) => {
    let { name } = this.props.language;
    return (
      <React.Fragment key={`airplane-${index}`}>
        <div className="d-flex justify-content-center text-captalize font-weight-bold text-third  font-smaller ">
          <FormattedMessage
            id="booking.airplanetype"
            defaultMessage="booking.airplanetype"
          />
        </div>
        <div className="d-felx justify-content-center font-smaller text-dark text-center font-weight-bold text-nowrap">
          {flight.equipment.name[name] === '*' || !flight.equipment.name[name]
            ? '--'
            : flight.equipment.name[name]}
        </div>
      </React.Fragment>
    );
  };
  renderDetails = (detailLst, ind, list) => {
    let { name, direction } = this.props.language;
    let { intl, tickets, user } = this.props;
    let showProvider = false;
    let stakeholder = localStorage.getItem('stakeholder');
    let profile = localStorage.getItem('profile');
    if (user && user?.userInfo && user?.userInfo?.profiles) {
      let profiles = user?.userInfo?.profiles
        .map((t) => t.profile)
        .filter((t) => t.displayName.en === process.env.AGENCY_NAME);
      if (profiles.map((item) => item.id).includes(parseInt(stakeholder)))
        showProvider = true;
    }
    return (
      <div className="m-0 p-0 pt-1 pb-1 font-weight-bold d-flex flex-wrap w-100">
        {detailLst.flights.map((flight, index) => (
          <React.Fragment key={`frg-${index}`}>
            {user && profile !== 'individual' && showProvider && index === 0 ? (
              <div className="d-flex py-1 px-2 m-0 w-100 justify-content-end align-items-start">
                <span
                  className="d-flex text-info font-smaller"
                  style={{ fontFamily: 'Vazir' }}
                >
                  {`${
                    detailLst.gateway.name
                      ? detailLst.gateway.name
                      : detailLst.gateway.code
                  }`}
                </span>
              </div>
            ) : null}
            <div
              className="p-0 col-12 font-weight-bold d-flex flex-row py-1"
              key={`flight-${index}`}
            >
              {this.renderAirplaneIconDetail(flight, ind, list)}
              {this.renderFlighPrimaryInfo(flight, index, ind)}
              {this.renderFlightDetails(flight, index, ind)}
            </div>
            {detailLst.flights.length > 1 &&
              index + 1 <= detailLst.flights.length &&
              detailLst.flights[index + 1] && (
                <div className="col-12 d-flex p-0 m-0 flex-row font-smaller">
                  <div className="col-1" />
                  <div className="d-flex flex-start col-3 p-0">
                    <hr
                      style={{ border: 'dotted 0.5px #cec0c0' }}
                      className="col-12 p-0"
                      size="1"
                    />
                  </div>
                  <div
                    className="d-flex flex-center align-items-center justify-content-between col-4 p-0 border-third"
                    style={{
                      backgroundColor: 'white',
                      borderRadius: 8,
                      borderWidth: 1,
                      borderStyle: 'dotted',
                    }}
                  >
                    <div className="d-flex px-2 ">
                      <span className="text-third font-smaller  text-third">
                        <FormattedMessage
                          id="booking.stopin"
                          defaultMessage="booking.stopin"
                        />
                      </span>
                      <span className="px-1">:</span>
                      <span className="text-primary  font-smaller ">{`${detailLst.flights[index].arrivalAirport.cityName[name]} `}</span>
                    </div>
                    <div className="d-flex px-2">
                      <span className="text-third font-smaller text-third">
                        <FormattedMessage
                          id="booking.stopduration"
                          defaultMessage="booking.stopduration"
                        />
                      </span>
                      <span className="px-1">:</span>
                      <span className="text-primary  font-smaller">
                        {detailLst.flights.length > 1 &&
                          index + 1 <= detailLst.flights.length &&
                          detailLst.flights[index + 1] &&
                          ` ${returnFormatTime(
                            dateDiff(
                              detailLst.flights[index + 1].departureDateTime,
                              detailLst.flights[index].arrivalDateTime,
                            ),
                            direction,
                            intl,
                          )}`}
                      </span>
                    </div>
                    {/* <div className="d-flex px-2">
                      <span className="text-third  justify-content-end  font-smaller  ">
                        <FormattedMessage
                          id="booking.operatedairline"
                          defaultMessage="booking.operatedairline"
                        />
                      </span>
                      <span className="px-1">:</span>
                      <span className="text-primary  font-smaller ">
                        {`${detailLst.flights[index].operatingAirline.name[name]}`}
                      </span>
                    </div> */}
                  </div>
                  <div className="d-flex p-0 flex-end col-3">
                    <hr
                      style={{ border: 'dotted 0.5px #cec0c0' }}
                      className="col-12 p-0"
                      size="1"
                    />
                  </div>
                  <div className="col-1" />
                </div>
              )}
            {detailLst.flights.length > 0 &&
              index + 1 === detailLst.flights.length && (
                <div className="col-12 d-flex m-0 justify-content-between  font-smaller px-2 py-1">
                  <div
                    className="d-flex justify-content-around px-0 cursor-pointer font-xsmall align-items-center"
                    onClick={() =>
                      this.setState(
                        {
                          showLoading: true,
                          selectedIndex: ind,
                        },
                        () => {
                          this.fetchCancelData(detailLst, ind);
                        },
                      )
                    }
                  >
                    <span className="text-primary-light ">
                      <FormattedMessage
                        id="booking.cancelrules"
                        defaultMessage="booking.cancelrules"
                      />
                    </span>
                    <span className="text-third px-1 ">{' : '}</span>
                    <div className="cancelingRule">
                      <ExternalLinkIcon size={12} color="#3d4a8f" />
                      <span className="text-primary-light">
                        <FormattedMessage
                          id="booking.view"
                          defaultMessage="booking.view"
                        />
                      </span>
                    </div>

                    {this.state.showLoading &&
                      ind === this.state.selectedIndex && (
                        <img
                          style={{ width: 44 }}
                          id={`loading-${ind}-${index}`}
                          src={require('../../../../content/images/icon/spinner-loading.gif')}
                          alt="spinner-loading"
                        />
                      )}
                  </div>
                  {(tickets && tickets.length) || detailLst.pnr ? (
                    <div className="d-flex p-0 m-0 ">
                      <span className="text-third px-1 font-gotham">
                        <FormattedMessage
                          id="booking.pnr"
                          defaultMessage="booking.pnr"
                        />
                      </span>
                      :
                      <span className="text-secondary-dark px-1 font-gotham text-uppercase">
                        {tickets.filter((item) => item.flightIndex === index)
                          .length
                          ? tickets?.filter(
                              (item) => item.flightIndex === index,
                            )?.[0].pnr
                          : detailLst.pnr
                          ? detailLst.pnr
                          : '--'}
                      </span>
                    </div>
                  ) : null}

                  {/* <div className="d-flex p-0 m-0 ">
                    <span className="d-flex text-third justify-content-end ">
                      <FormattedMessage
                        id="booking.operatedairline"
                        defaultMessage="booking.operatedairline"
                      />
                      <span className="d-flex text-primary justify-content-end">
                        {`: ${detailLst.flights[index].operatingAirline.name[name]}`}
                      </span>
                    </span>
                  </div> */}
                </div>
              )}
          </React.Fragment>
        ))}
      </div>
    );
  };
  // render card for detil of each fligh
  renderDetailFrame = (details, isModal) => {
    if (details) {
      let {
          language: { direction },
          location,
        } = this.props,
        list = details.itineraries ? details.itineraries : details,
        parsedQueryStr = Object.fromEntries(
          new URLSearchParams(location.search),
        ),
        adultCount = parsedQueryStr.ad ? parseInt(parsedQueryStr.ad) : 0,
        childCount = parsedQueryStr.ch ? parseInt(parsedQueryStr.ch) : 0,
        infantCount = parsedQueryStr.in ? parseInt(parsedQueryStr.in) : 0;
      return (
        <div onClick={(event) => event.stopPropagation()}>
          {list.map((item, ind) => (
            <div
              className={`col-12 p-0 font-weight-bold d-flex flex-row 
              ${
                list.length - 1 == ind
                  ? ' default-border-bottom-radius-small '
                  : ''
              }
              ${
                details.length > 2 && ind % 2 !== 0
                  ? 'bg-third-light'
                  : 'bg-gray-light'
              } `}
              style={{
                borderBottom:
                  (ind === 0 && details.length > 1) || ind != details.length - 1
                    ? 'dashed  1px'
                    : '',
                borderColor:
                  ind === 0 || ind != details.length - 1 ? 'silver' : '',
              }}
              key={`flightDetails-${this.props.flightIndex}-${ind}`}
            >
              <div className="d-flex flex-column  p-0 justify-content-center font-large">
                <div className="d-flex flex-row col-12 p-0 justify-content-start font-large">
                  <div
                    className="d-flex flex-row justify-content-center  p-0"
                    style={
                      direction === 'ltr'
                        ? { borderRight: 'dashed 1px silver ', width: 30 }
                        : { borderLeft: 'dashed 1px silver', width: 30 }
                    }
                  >
                    <div className="d-flex justify-content-center align-items-center">
                      {/* {direction === 'ltr' && (
												<img
													style={{ width: 22, height: 30 }}
													alt=''
													src={require(`../../../content/images/icon/${
														ind == 0 || details.length > 2
															? 'origin.png'
															: 'destination.png'
													}`)}
												/>
											)}
											{direction === 'rtl' && (
												<img
													style={{ width: 22, height: 30 }}
													alt=''
													src={require(`../../../content/images/icon/${
														ind == 0 ? 'destination.png' : 'origin.png'
													}`)}
												/>
											)} */}
                      {/* <DepartureAirplaneIcon color="#3d4a8f" /> */}
                      {ind == 0 || details.itineraries > 2 ? (
                        <DepartureAirplaneIcon size={18} color={'#3d4a8f'} />
                      ) : (
                        <ArrivalAirplaneIcon size={18} color={'#3d4a8f'} />
                      )}
                    </div>
                  </div>
                </div>
              </div>

              {this.renderDetails(item, ind, list)}
            </div>
          ))}
          {this.props.showPrice && details.adultPrice && (
            <div className="d-flex py-2  flex-wrap justify-content-between bg-primary text-white h3 font-weight-bold align-items-center text-captalize m-0 ">
              <div className="d-flex  flex-column justify-content-center bg-primary text-white h3  font-weight-bold align-items-center text-captalize  px-1">
                <div className="text-white d-flex font-small text-third">
                  <FormattedMessage
                    id="booking.priceperadult"
                    defaultMessage="booking.priceperadult"
                  />
                </div>

                <div
                  className="text-white d-flex px-2 pt-2 font-small"
                  style={{ direction: 'ltr' }}
                >
                  {/* {` ${numberWithCommas(
                    (details.adultPrice.totalPrice / 260000).toFixed(2)
                  )} ${this.props.intl.formatMessage({
                    id: "booking.toman",
                  })}`} */}
                  {`${
                    details.adultCount ? details.adultCount : adultCount
                  } X ${numberWithCommas(
                    (
                      (parseFloat(details.adultPrice.totalPrice) +
                        parseFloat(details.adultPrice.commission)) /
                      10
                    ).toFixed(0),
                  )} ${this.props.intl.formatMessage({
                    id: 'booking.toman',
                  })}`}
                </div>
              </div>
              {details.childCount || childCount
                ? details.childPrice.totalPrice > 0 && (
                    <div className="d-flex   flex-column justify-content-center bg-primary text-white h3 font-weight-bold align-items-center text-captalize ">
                      <div className="text-white d-flex font-small text-third">
                        <FormattedMessage
                          id="booking.priceperchild"
                          defaultMessage="booking.priceperchild"
                        />
                      </div>

                      <div
                        className="text-white d-flex px-2 pt-2 font-small"
                        style={{ direction: 'ltr' }}
                      >
                        {/* {` ${numberWithCommas(
                      (details.childPrice.totalPrice / 260000).toFixed(2)
                    )} ${this.props.intl.formatMessage({
                      id: "booking.toman",
                      defaultMessage: "booking.toman",
                    })}`} */}
                        {` ${
                          details.childCount ? details.childCount : childCount
                        } X ${numberWithCommas(
                          (
                            (parseFloat(details.childPrice.totalPrice) +
                              parseFloat(details.childPrice.commission)) /
                            10
                          ).toFixed(0),
                        )} ${this.props.intl.formatMessage({
                          id: 'booking.toman',
                          defaultMessage: 'booking.toman',
                        })}`}
                      </div>
                    </div>
                  )
                : ''}

              {details.infantCount || infantCount
                ? details.infantPrice.totalPrice > 0 && (
                    <div className="d-flex   flex-column justify-content-center bg-primary text-white h3 font-weight-bold align-items-center text-captalize ">
                      <div className="text-white d-flex font-small text-third">
                        <FormattedMessage
                          id="booking.priceperinfant"
                          defaultMessage="booking.priceperinfant"
                        />
                      </div>

                      <div
                        className="text-white d-flex px-2 pt-2 font-small"
                        style={{ direction: 'ltr' }}
                      >
                        {/* {` ${numberWithCommas(
                      (details.infantPrice.totalPrice / 260000).toFixed(2)
                    )} ${this.props.intl.formatMessage({
                      id: "booking.toman",
                      defaultMessage: "booking.toman",
                    })}`} */}

                        {`  ${
                          details.infantCount
                            ? details.infantCount
                            : infantCount
                        } X  ${numberWithCommas(
                          (
                            (parseFloat(details.infantPrice.totalPrice) +
                              parseFloat(details.infantPrice.commission)) /
                            10
                          ).toFixed(0),
                        )} ${this.props.intl.formatMessage({
                          id: 'booking.toman',
                          defaultMessage: 'booking.toman',
                        })}`}
                      </div>
                    </div>
                  )
                : ''}
              <div
                className="d-flex py-1 rounded  my-1 mx-1 flex-column justify-content-center bg-white h3 px-2 font-weight-bold align-items-center text-captalize "
                // style={{ border: "solid 1px white" }}
              >
                <div className="text-primary d-flex font-small">
                  <FormattedMessage
                    id="booking.totalprice"
                    defaultMessage="booking.totalprice"
                  />
                </div>
                <div className="text-secondary-dark d-flex px-2 pt-2 font-small">
                  {/* {` ${numberWithCommas(
                    (details.totalPrice / 260000).toFixed(2)
                  )} ${this.props.intl.formatMessage({
                    id: "booking.toman",
                    defaultMessage: "booking.toman",
                  })}`} */}
                  {` ${numberWithCommas(
                    (
                      (parseFloat(details.totalPrice) +
                        parseFloat(details.commission)) /
                      10
                    ).toFixed(0),
                  )} ${this.props.intl.formatMessage({
                    id: 'booking.toman',
                    defaultMessage: 'booking.toman',
                  })}`}
                </div>
              </div>
            </div>
          )}
        </div>
      );
    } else return null;
  };
  // render flight detail information
  renderFlightDetails = (item, index, ind) => {
    let { name, direction } = this.props.language,
      resBookDesigCabinName = item.bookingClassAvails
        ? item.bookingClassAvails.resBookDesigCabinName
        : item.resBookDesigCabinName,
      resBookDesigCode = item.bookingClassAvails
        ? item.bookingClassAvails.resBookDesigCode
        : item.resBookDesigCode;

    return (
      <div className="col-xl-4 col-3 p-0 m-0 d-flex flex-column justify-content-center align-items-center">
        <div className="d-flex flex-xl-row flex-column w-100">
          <div className="col-xl-4 w-100 d-flex flex-column p-0 justify-content-xl-center justify-content-between text-captalize font-weight-bold font-smaller">
            {this.renderAirplaneType(item, index)}
          </div>
          <div className="col-xl-4 w-100 d-flex flex-column justify-content-xl-center justify-content-between p-0 text-center text-captalize font-weight-bold font-smaller">
            <div className={`text-third text-center`}>
              <FormattedMessage
                id="booking.travelclass"
                defaultMessage="booking.travelclass"
              />
            </div>
            <div
              className="text-dark text-center text-truncate"
              style={{ direction }}
            >
              {` ${
                resBookDesigCabinName && resBookDesigCabinName[name]
              }(${resBookDesigCode})`}
            </div>
          </div>

          <div className="col-xl-4 w-100 d-flex flex-column p-0 justify-content-xl-center justify-content-between text-captalize font-weight-bold font-smaller">
            <div className={`text-third text-center`}>
              <FormattedMessage
                id="booking.baggages"
                defaultMessage="booking.baggages"
              />
            </div>
            <div className="text-dark text-center pointer">
              {item?.baggage?.length > 0 ? (
                item.baggage
                  .filter((bag) => bag.type === 'ADT')[0]
                  .unit.toLowerCase() === 'kg' &&
                item.baggage.filter((bag) => bag.type === 'ADT')[0].quantity >
                  0 ? (
                  `${
                    item.baggage.filter((bag) => bag.type === 'ADT')[0].quantity
                  }  ${this.props.intl.formatMessage({
                    id: 'booking.kg',
                  })}`
                ) : item.baggage.filter((bag) => bag.type === 'ADT')[0]
                    .quantity > 0 ? (
                  <Tooltip
                    position={'top'}
                    content={`${
                      item.baggage.filter((bag) => bag.type === 'ADT')[0]
                        .quantity
                    } * ${
                      resBookDesigCabinName['en']
                        .toLowerCase()
                        .includes('economy')
                        ? 23
                        : 32
                    } ${this.props.intl.formatMessage({
                      id: 'booking.kg',
                      defaultMessage: 'booking.kg',
                    })}`}
                    direction={direction}
                    backgroundColor="warning"
                    textColor="dark"
                  >
                    <span

                    // cabin class define the weight of package in baggage => in economy class is equal to 23 else equal to 32
                    >
                      <SuitcaseIcon size={14} color="#03353d" />
                      {`${
                        //just show baggage of adult
                        item.baggage.filter((bag) => bag.type === 'ADT')[0]
                          .quantity
                      } ${this.props.intl.formatMessage({
                        id:
                          'booking.' +
                          item.baggage
                            .filter((bag) => bag.type === 'ADT')[0]
                            .unit.toLowerCase(),
                        defaultMessage:
                          'booking.' +
                          item.baggage
                            .filter((bag) => bag.type === 'ADT')[0]
                            .unit.toLowerCase(),
                      })}`}
                    </span>
                  </Tooltip>
                ) : (
                  this.props.intl.formatMessage({
                    id: 'booking.nobaggage',
                    defaultMessage: 'booking.nobaggage',
                  })
                )
              ) : (
                '--'
              )}
            </div>
          </div>
          {/* <div className='col-3 p-0 text-center text-captalize font-weight-bold font-smaller'>
            <div className={`${"text-third"} text-center`}>
              <FormattedMessage
                id='booking.operatedairline'
                defaultMessage='booking.operatedairline'
              />
            </div>
            <div
              className='text-secondary-dark text-center text-truncate'
              style={{ direction }}>
              {`${item.operatingAirline.name[name]}`}
            </div>
          </div> */}
        </div>
      </div>
    );
  };
  // show renderMiladiDate in rtl direction
  renderMiladiDate = (date, index) => {
    if (date !== undefined && date !== null && date != '') {
      date = date.split('T')[0].split('-');
      return `${date[2]} ${fullMonths['ltr']['fa'][date[1] - 1]} ${date[0]}`;
    }
  };
  //render main info in detail box for each flight
  renderFlighPrimaryInfo = (item, index, ind) => {
    let { name, direction } = this.props.language,
      diffTime =
        new Date(item.arrivalDateTime.split('T')[0]).getTime() -
        new Date(item.departureDateTime.split('T')[0]).getTime();
    let diffDays = Math.floor(diffTime / (1000 * 60 * 60 * 24));
    let valueLenght = 25;
    let width = window.screen.width;
    switch (true) {
      case 1300 <= width && width < 1670:
        valueLenght = 20;
        break;
      case 1200 <= width && width < 1300:
        valueLenght = 15;
        break;
      case 100 <= width && width < 1200:
        valueLenght = 18;
        break;
      case 1300 <= width && width < 1360:
        valueLenght = 17;
        break;
      case 1200 <= width && width < 1300:
        valueLenght = 14;
        break;
      default:
        valueLenght = 34;
    }
    let firstAirportname = item.departureAirport.name[name];
    let secondAirportname = item.arrivalAirport.name[name];
    return (
      <div className="col-7 p-0 d-flex flex-row justify-content-center">
        <div className="col-4 d-flex flex-column justify-content-center text-nowrap">
          <div className="d-flex justify-content-center font-weight-bold  align-items-center font-smaller text-primary-light ">
            {`${item.departureAirport.cityName[name]} (${item.departureAirport.code})`}
          </div>
          <div className="d-flex  justify-content-center font-weight-bold text-secondary align-items-center font-smaller">
            {item.departureDateTime.split('T')[1].substring(0, 5)}
          </div>
          <Tooltip
            position={'top'}
            content={`${item.departureAirport.name[name]}- ${
              item.departureAirport.terminal
                ? `${this.props.intl.formatMessage({
                    id: 'booking.terminal',
                    defaultMessage: 'booking.terminal',
                  })} ${item.departureAirport.terminal}`
                : this.props.intl.formatMessage({
                    id: 'booking.mainterminal',
                    defaultMessage: 'booking.mainterminal',
                  })
            }`}
            direction={direction}
            backgroundColor="warning"
            textColor="dark"
          >
            <div
              className="d-flex flex-column text-truncate mx-auto justify-content-start font-weight-bold  
            text-primary  align-items-center font-xsmall"
            >
              <span>
                {firstAirportname.length > valueLenght
                  ? `${
                      firstAirportname && firstAirportname.slice(0, valueLenght)
                    }...`
                  : firstAirportname
                  ? firstAirportname
                  : '---'}
              </span>
              <span>
                {item.departureAirport.terminal
                  ? `${this.props.intl.formatMessage({
                      id: 'booking.terminal',
                      defaultMessage: 'booking.terminal',
                    })} ${item.departureAirport.terminal}`
                  : this.props.intl.formatMessage({
                      id: 'booking.mainterminal',
                      defaultMessage: 'booking.mainterminal',
                    })}
              </span>
            </div>
          </Tooltip>

          <div className="px-1 d-flex justify-content-center text-captalize text-third font-xsmall ">
            {direction === 'rtl' &&
              returnFlightDate(item.departureDateTime, 'fa', true)}
          </div>
          {direction === 'rtl' && (
            <div className="px-1 d-flex justify-content-center text-captalize text-third font-xsmall">
              {this.renderMiladiDate(item.departureDateTime)}
            </div>
          )}
          {direction === 'ltr' && (
            <div className="px-1 d-flex justify-content-center text-captalize text-third font-xsmall">
              {returnFlightDate(
                item.departureDateTime,
                'en',
                direction === 'ltr' ? true : false,
              )}
            </div>
          )}
        </div>
        <div className="col-4 d-flex flex-row justify-content-center align-items-center">
          {this.renderFlightDetailRouteImage(item)}
        </div>
        <div className="col-4 d-flex flex-column justify-content-center text-nowrap">
          <div className="d-flex justify-content-center align-items-center font-weight-bold font-smaller text-primary ">
            {`${item.arrivalAirport.cityName[name]} (${item.arrivalAirport.code})`}
          </div>
          <div
            className="d-flex justify-content-center font-weight-bold text-dark align-items-center font-smaller"
            style={{ direction }}
          >
            {`${item.arrivalDateTime.split('T')[1].substring(0, 5)} ${
              diffDays > 0
                ? `(+${diffDays})`
                : diffDays < 0
                ? `(${diffDays})`
                : ''
            }`}
          </div>
          <Tooltip
            position={'top'}
            content={`${item.arrivalAirport.name[name]} - ${
              item.arrivalAirport.terminal
                ? `${this.props.intl.formatMessage({
                    id: 'booking.terminal',
                    defaultMessage: 'booking.terminal',
                  })} ${item.arrivalAirport.terminal}`
                : this.props.intl.formatMessage({
                    id: 'booking.mainterminal',
                    defaultMessage: 'booking.mainterminal',
                  })
            }`}
            direction={direction}
            backgroundColor="warning"
            textColor="dark"
          >
            <div
              className="d-flex flex-column mx-auto text-truncate justify-content-start 
            font-weight-bold text-primary align-items-center font-xsmall"
            >
              <span>
                {secondAirportname.length > valueLenght
                  ? `${
                      secondAirportname &&
                      secondAirportname.slice(0, valueLenght)
                    }...`
                  : secondAirportname
                  ? secondAirportname
                  : '---'}
              </span>
              <span>{`${
                item.arrivalAirport.terminal
                  ? `${this.props.intl.formatMessage({
                      id: 'booking.terminal',
                      defaultMessage: 'booking.terminal',
                    })} ${item.arrivalAirport.terminal}`
                  : this.props.intl.formatMessage({
                      id: 'booking.mainterminal',
                      defaultMessage: 'booking.mainterminal',
                    })
              }`}</span>
            </div>
          </Tooltip>

          <div className="px-1 d-flex justify-content-center text-captalize text-third font-xsmall">
            {direction === 'rtl' &&
              returnFlightDate(item.arrivalDateTime, 'fa', this.props.intl)}
          </div>
          {direction === 'rtl' && (
            <div className="px-1 d-flex justify-content-center text-captalize text-third font-xsmall">
              {this.renderMiladiDate(item.arrivalDateTime)}
            </div>
          )}
          {direction === 'ltr' && (
            <div className="px-1 d-flex justify-content-center text-captalize text-third font-xsmall">
              {returnFlightDate(item.arrivalDateTime, 'en', this.props.intl)}
            </div>
          )}
        </div>
      </div>
    );
  };
  // show airplane and route with line to show airports data
  renderFlightDetailRouteImage = (item) => {
    let { direction } = this.props.language;
    return (
      <div className="d-flex flex-column w-100 justify-content-center">
        <div className="d-flex text-center font-weight-bold w-100 align-items-center ">
          <div className="d-flex text-secondary-dark justify-content-center text-primary  font-smaller w-100  ">
            <span className="text-third text-center font-smaller">
              {`${this.props.intl.formatMessage({
                id: 'booking.duration',
                defaultMessage: 'booking.duration',
              })} `}
              <span className="text-secondary-dark">{`: ${
                item.flightDuration !== 0
                  ? item.flightDuration.substring(0, 5)
                  : '--'
              }`}</span>
            </span>
          </div>
        </div>
        <div className="d-flex justify-content-center">
          <FlightPath direction={direction} />
        </div>
        {this.renderFlightNumber(item)}
      </div>
    );
  };
  renderFlightNumber(item) {
    return (
      <div className="d-flex text-center font-weight-bold w-100 align-items-center ">
        <div className="d-flex text-secondary-dark justify-content-center text-primary  font-smaller w-100   ">
          <span className="text-third text-center font-smaller">
            {`${this.props.intl.formatMessage({
              id: 'booking.flightnumber',
              defaultMessage: 'booking.flightnumber',
            })} `}
            <span className="text-secondary-dark">{` ${item.flightNumber}`}</span>
          </span>
        </div>
      </div>
    );
  }
  // show operating Airline for name of airline
  renderAirplaneIconDetail(flight, ind, itenery) {
    let { name } = this.props.language;
    let airlineCode = '';
    airlineCode = flight.operatingAirline.code
      ? flight.operatingAirline.code
      : 'Airplane';
    return (
      <div
        className={`d-flex flex-column align-items-center justify-content-center `}
      >
        <div className="d-flex w-100">
          <div className="d-flex justify-content-center align-items-center py-0 px-2 m-0 w-100">
            <span
              className={`p-1 font-weight-bold font-smaller ${
                itenery[ind].isCharter ? 'text-danger' : 'systemType-text'
              }  `}
            >
              <FormattedMessage
                id={`booking.${
                  itenery[ind].isCharter ? 'charter' : 'systemic'
                }`}
                defaultMessage={`booking.${
                  itenery[ind].isCharter ? 'charter' : 'systemic'
                }`}
              />
            </span>
          </div>
        </div>
        <img
          className={`d-flex justify-content-center rounded-circle border border-1`}
          style={{ width: 32, height: 32 }}
          src={returnAirlineLogos(airlineCode)}
          alt="airline Code"
        />

        <div className="d-flex justify-content-center align-items-center font-xsmall pt-1 text-nowrap  text-center font-weight-bold px-1 text-primary">
          {flight.operatingAirline.name[name]}
        </div>
      </div>
    );
  }

  render() {
    return (
      <React.Fragment>
        <div className="d-sm-block d-none default-border-radius">
          {this.renderDetailFrame(
            this.props.details,
            this.props.isModal,
            this.props.tickets,
          )}
          {this.renderCancelRulesModal()}
        </div>
      </React.Fragment>
    );
  }
  //#endregion
}
function mapStateToProps(state, props) {
  return {
    language: state.language,
    user: state.user,
  };
}
BookingFlightDetails.propTypes = {
  bookingId: propTypes.string,
  flight: propTypes.object,
  showPrice: propTypes.bool,
  intl: propTypes.object,
  tickets: propTypes.array,
  details: propTypes.oneOfType([propTypes.array, propTypes.object]),
  flightType: propTypes.string,
  isModal: propTypes.bool,
  isBooking: propTypes.bool,
  flightIndex: propTypes.number,
};
BookingFlightDetails.defaultProps = {
  bookingId: '',
  flight: {},
  showPrice: false,
  intl: {},
  tickets: [],
  details: [] || {},
  flightType: '',
  isModal: false,
  isBooking: false,
  flightIndex: 0,
};
export default injectIntl(
  connect(mapStateToProps)(withRouter(BookingFlightDetails)),
);
